var LeftNav;

module.exports = LeftNav = (function() {
  function LeftNav() {
    var ref, ref1;
    this.$nav = $('#left-nav-categories');
    this.$navUl = (ref = this.$nav) != null ? ref.find('> ul') : void 0;
    this.$navList = (ref1 = this.$navUl) != null ? ref1.children() : void 0;
    if (!this.$navList.length) {
      return;
    }
    this.navHeight = this.$nav.outerHeight();
    this.navPadding = this.$navUl.position().top;
    this.arrowTop = parseInt($(this.$navList.find('.arrow')[0]).css('top'));
    this.displacementCache = [];
    this.setSubNavPosition();
    this.enableSuvNav();
  }

  LeftNav.prototype.setSubNavPosition = function() {
    var $flyout, $nav, displacement, i, len, nav, ref, results;
    ref = this.$navList;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      nav = ref[i];
      $nav = $(nav);
      $flyout = $nav.find('.left-nav-flyout');
      if (!$flyout) {
        continue;
      }
      if (!(this.subnavHeight && this.subnavPadding)) {
        $flyout.css({
          display: 'block',
          visibility: 'hidden'
        });
        this.subnavHeight = $($flyout.find('li')[0]).outerHeight(true);
        $flyout.removeAttr('style');
      }
      displacement = this.calculateDisplacement({
        top: $nav.position().top,
        height: $flyout.outerHeight(),
        arrowPosition: Math.floor(($flyout.find('ul:first').children().length) / 2) || 1
      });
      results.push(this.applyDisplacement($flyout, displacement));
    }
    return results;
  };

  LeftNav.prototype.calculateDisplacement = function(arg) {
    var arrowPosition, displacement, height, top;
    top = arg.top, height = arg.height, arrowPosition = arg.arrowPosition;
    displacement = this.displacementCache[arrowPosition];
    if (!displacement) {
      displacement = (this.subnavHeight - this.arrowTop) * (1 - arrowPosition) - this.arrowTop / 2;
      this.displacementCache[arrowPosition] = displacement;
    }
    if (top + displacement < this.navPadding) {
      return this.navPadding - top;
    }
    if (top + displacement + height > this.navHeight - this.navPadding) {
      return this.navHeight - this.navPadding - top - height;
    }
    return displacement;
  };

  LeftNav.prototype.applyDisplacement = function($flyout, displacement) {
    $flyout.css('top', displacement + "px");
    return $flyout.find('.arrow').css('top', ((displacement * -1) + this.arrowTop) + "px");
  };

  LeftNav.prototype.enableSuvNav = function() {
    return this.$nav.removeClass('flyout-disabled');
  };

  return LeftNav;

})();

//# sourceMappingURL=data:application/json;base64,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
